import { Controller } from "@hotwired/stimulus"
import { Haptics } from "../lib/haptics"

// Explosive confetti celebration — bursts from center with multiple waves.
// No external libraries. Pure CSS animations + JS generation.
export default class extends Controller {
  static values = { count: { type: Number, default: 150 }, duration: { type: Number, default: 4000 } }

  connect() {
    // Launch multiple waves for an explosive feel
    this.launchWave(0, Math.floor(this.countValue * 0.6))   // Big burst immediately
    setTimeout(() => this.launchWave(0.1, Math.floor(this.countValue * 0.25)), 300)  // Second wave
    setTimeout(() => this.launchWave(0.2, Math.floor(this.countValue * 0.15)), 700)  // Trailing pieces
    Haptics.success()
  }

  launchWave(baseDelay, count) {
    // Colors live as .gl-confetti-piece--N classes (goatleads/components/_confetti.scss)
    // — a random modifier class picks one, so no hex literal goes into inline
    // style.background.
    const colorClassCount = 18
    const shapes = ['circle', 'rect', 'strip']

    let container = document.querySelector('.gl-confetti-container')
    if (!container) {
      container = document.createElement('div')
      container.className = 'gl-confetti-container'
      container.setAttribute('aria-hidden', 'true')
      document.body.appendChild(container)

      // Clean up after all waves complete
      setTimeout(() => container.remove(), this.durationValue + 3000)
    }

    for (let i = 0; i < count; i++) {
      const piece = document.createElement('div')
      const colorClass = `gl-confetti-piece--${1 + Math.floor(Math.random() * colorClassCount)}`
      const shape = shapes[Math.floor(Math.random() * shapes.length)]

      // Start from center of screen and explode outward
      const startX = 45 + Math.random() * 10 // Center 45-55%
      const angle = Math.random() * Math.PI * 2 // Full 360 degrees
      const velocity = 300 + Math.random() * 500 // How far it flies
      const endX = Math.cos(angle) * velocity
      const endY = Math.sin(angle) * velocity - 200 // Bias upward first

      const delay = baseDelay + Math.random() * 0.4
      const duration = 1.5 + Math.random() * 2
      const rotation = Math.random() * 720 - 360
      const size = shape === 'strip' ? 3 : (5 + Math.random() * 8)
      const height = shape === 'strip' ? (12 + Math.random() * 16) :
                     shape === 'circle' ? size : (size * (0.4 + Math.random() * 0.4))
      const radius = shape === 'circle' ? '50%' : shape === 'strip' ? '2px' : `${Math.random() * 3}px`

      piece.className = `gl-confetti-piece gl-confetti-burst ${colorClass}`
      piece.style.cssText = `
        left: ${startX}%;
        top: 40%;
        width: ${size}px;
        height: ${height}px;
        border-radius: ${radius};
        --end-x: ${endX}px;
        --end-y: ${endY}px;
        --spin: ${rotation}deg;
        animation-delay: ${delay}s;
        animation-duration: ${duration}s;
      `

      container.appendChild(piece)
    }
  }
}
